import { Component, OnInit, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, BehaviorSubject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { ISimilarSearchModel, SimilarSearchModel } from '../models/similar-search-model';
import { ISearchResultModel, SearchResultModel } from '../models/search-result-model';
import { SimilarVehicleService } from '../service/similar-vehicle.service';
import { ShortListService } from '../service/short-list.service';

// Third Party
import { TabComponent, SelectEventArgs, HeaderModel, SelectingEventArgs } from '@syncfusion/ej2-angular-navigations';

const viewTypes = ['similar', 'linked'];

@Component({
  selector: 'lud-similar-vehicle',
  templateUrl: './similar-vehicle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimilarVehicleComponent implements OnInit {
  static route = ':viewType'; //'similar' | 'linked';

  viewType: string = 'similar'; // from route
  headerText: HeaderModel[] = [{ text: 'Similar Vehicles' }, { text: 'Linked Vehicles' }];

  viewTypeResult: string = '';//'card' | 'list' | 'gantt' = 'list';

  @ViewChild('tabObj', { static: true }) tabInstance: TabComponent;

  isLoadingSimilar$ = new BehaviorSubject(false);
  itemsToShowSimilar$ = new BehaviorSubject(null);
  totalItemsSimilar$ = new BehaviorSubject(0);

  isLoadingLinked$ = new BehaviorSubject(false);
  itemsToShowLinked$ = new BehaviorSubject(null);
  totalItemsLinked$ = new BehaviorSubject(0);

  private masterItemsToShowSimilar = [];
  private masterItemsToShowLinked = [];

  private subscriptions: Subscription[] = [];

  constructor(
    private similarVehicleService: SimilarVehicleService,
    private shortListService: ShortListService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {

    this.subscriptions.push(
      this.shortListService.reset$
        .subscribe(result => {
          console.log('SimilarVehicleComponent. reset().', result);

          this.itemsToShowSimilar$.next(JSON.parse(JSON.stringify(this.masterItemsToShowSimilar)));
          this.itemsToShowLinked$.next(JSON.parse(JSON.stringify(this.masterItemsToShowLinked)));
        })
    );
  }

  ngOnInit() {
    const viewType = this.activatedRoute.snapshot.paramMap.get('viewType');
    if (viewType) {
      var viewTypeIndex = viewTypes.indexOf(viewType.toLowerCase());
      if (viewTypeIndex > -1) {
        this.viewType = viewType;
        this.tabInstance.selectedItem = viewTypeIndex;
        //this.tabInstance.dataBind();
      }
    }

    if (!this.hasValidRoute()) {
      //this.router.navigate(['/find-vehicles']);
      //return;
    }

    this.subscriptions.push(
      this.similarVehicleService.active$
        .pipe(
          //skip(1),
          switchMap(searchModel => {
            this.isLoadingSimilar$.next(true);

            return this.similarVehicleService.similar(searchModel)
          }),
          tap((res: ISearchResultModel) => {
            this.isLoadingSimilar$.next(false);

            this.masterItemsToShowSimilar = res.items;
            this.itemsToShowSimilar$.next(JSON.parse(JSON.stringify(res.items || [])));
            this.totalItemsSimilar$.next(res.totalItems);
          })
        ).subscribe()
    );

    this.subscriptions.push(
      this.similarVehicleService.active$
        .pipe(
          //skip(1),
          switchMap(searchModel => {
            this.isLoadingLinked$.next(true);

            return this.similarVehicleService.linked(searchModel)
          }),
          tap((res: ISearchResultModel) => {
            this.isLoadingLinked$.next(false);

            this.masterItemsToShowLinked = res.items;
            this.itemsToShowLinked$.next(JSON.parse(JSON.stringify(res.items || [])));
            this.totalItemsLinked$.next(res.totalItems);
          })
        ).subscribe()
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  selecting(e: SelectingEventArgs) {
    //if (e.isSwiped) {
    //  e.cancel = true;
    //}
  }

  selected(e: SelectEventArgs) {
    if (e.selectedIndex < viewTypes.length) {
      this.viewType = viewTypes[e.selectedIndex];
    }
  }

  private hasValidRoute(): boolean {
    var derivativeId = +this.activatedRoute.snapshot.paramMap.get('id');
    var derivativeType = this.activatedRoute.snapshot.paramMap.get('derivativeType');
    var countryCode = this.activatedRoute.snapshot.paramMap.get('countryCode');

    var isValid = derivativeId > 0 && derivativeType != null && countryCode != null;
    if (isValid) {
      this.similarVehicleService.update(new SimilarSearchModel(derivativeId, derivativeType, countryCode));
    }

    return isValid;
  }
}
